
$(document).ready(function() {
  updateModel()
    $(document).on('change', '.variant-picker__option-values input', function () {
      updateModel();
      console.log('changed');
    });
  function updateModel(){
    var checkedValue = $('.variant-picker__option-values input:checked').attr('color-value');

        var blue = "https://cdn.shopify.com/3d/models/d81f9fc1292a9fe3/blue.glb";
        var black = "https://cdn.shopify.com/3d/models/1e7ed62bdc75c1f1/black.glb";
        var white = "https://cdn.shopify.com/3d/models/83f1848746be5e53/white_1.glb";
        var green = "https://cdn.shopify.com/3d/models/92510f3f8a583bc2/green.glb";

        if(checkedValue == 'Blue') {
            $('model-viewer').attr('src', blue);
        } else if(checkedValue == 'Black') {
            $('model-viewer').attr('src', black);
        } else if(checkedValue == 'White') {
            $('model-viewer').attr('src', white);
        } else if(checkedValue == 'Green') {
            $('model-viewer').attr('src', green);
        }
  }


  $('.camera_on').click(function(){
    $('.camera_on_inner').toggleClass('control_off');
    if ($('.camera_on_inner').hasClass('control_off')) {
        // Remove the camera-controls attribute
        $('model-viewer').removeAttr('camera-controls');
    } else {
        // Add the camera-controls attribute
        $('model-viewer').attr('camera-controls', '');
    }
  })

  if(window.outerWidth < 999) {
    $('model-viewer').removeAttr('camera-controls');
  }

  
});


// Venmo accelerated checkout button
(function () {
  var VENMO_SELECTORS = [
    '[aria-label="Venmo"]',
    '[data-testid="Shopify.Venmo"]',
    '[data-testid="Venmo-payment-button"]',
    'button[class*="venmo"]',
    '[data-payment-method*="venmo"]'
  ];

  function findVenmoButton(formId) {
    var root = (formId && document.getElementById(formId)) || document;
    for (var i = 0; i < VENMO_SELECTORS.length; i++) {
      var el = root.querySelector(VENMO_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.venmo-checkout-btn');
    if (!btn) return;
    var wrapper = btn.closest('.venmo-checkout-wrapper');
    var formId = wrapper && wrapper.getAttribute('data-venmo-form');
    var venmoBtn = findVenmoButton(formId);
    if (venmoBtn) venmoBtn.click();
  });
})();

// Google Pay accelerated checkout button
(function () {
  var gpayAvailable = false;

  // Ordered from most specific to least. Update if Authorize.net changes its markup.
  var GPAY_SELECTORS = [
    '[aria-label="Google Pay"]',
    '[data-testid="Shopify.GooglePay"]',
    'button[class*="gpay"]',
    'button[class*="google-pay"]',
    '[data-payment-method*="google"]'
  ];

  function findGPayButton(formId) {
    var root = (formId && document.getElementById(formId)) || document;
    for (var i = 0; i < GPAY_SELECTORS.length; i++) {
      var el = root.querySelector(GPAY_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function showWrappers() {
    document.querySelectorAll('.gpay-checkout-wrapper[hidden]').forEach(function (w) {
      w.removeAttribute('hidden');
    });
  }

  // Event delegation survives product-rerender re-renders
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.gpay-checkout-btn');
    if (!btn) return;
    var wrapper = btn.closest('.gpay-checkout-wrapper');
    var formId = wrapper && wrapper.getAttribute('data-gpay-form');
    var gpayBtn = findGPayButton(formId);
    if (gpayBtn) gpayBtn.click();
  });

  // Re-show wrappers whenever product-rerender updates its children
  document.querySelectorAll('product-rerender').forEach(function (el) {
    new MutationObserver(function () {
      if (gpayAvailable) showWrappers();
    }).observe(el, { childList: true });
  });

  // Fallback for iOS Chrome: PaymentRequest.canMakePayment() returns false on iOS WebKit
  // even when Authorize.net has rendered a Google Pay button. Watch the DOM for the
  // underlying payment button appearing, which is authoritative proof it's available.
  function startDOMFallback() {
    if (findGPayButton(null)) {
      gpayAvailable = true;
      showWrappers();
      return;
    }
    var observer = new MutationObserver(function () {
      if (!gpayAvailable && findGPayButton(null)) {
        gpayAvailable = true;
        showWrappers();
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 10000);
  }

  function init() {
    // Primary detection: PaymentRequest API (works on Android Chrome, desktop Chrome)
    if (typeof PaymentRequest !== 'undefined') {
      try {
        new PaymentRequest(
          [{ supportedMethods: 'https://google.com/pay' }],
          { total: { label: 'tCheck', amount: { currency: 'USD', value: '0.01' } } }
        ).canMakePayment().then(function (ok) {
          if (ok) { gpayAvailable = true; showWrappers(); }
        }).catch(function () {});
      } catch (e) {}
    }

    // Secondary detection: DOM presence of the Authorize.net/Shopify Google Pay button.
    // Handles iOS Chrome and other browsers where canMakePayment() may not reliably
    // report Google Pay even when the payment processor has rendered the button.
    startDOMFallback();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* -----------------------------------------------------------------------
   Direct checkout — skip cart on product pages
   After a successful "Add to cart", redirect straight to /checkout
   instead of opening the cart drawer. Fires on both the main ATC button
   and the sticky bar button since both use the same product-form.
   ----------------------------------------------------------------------- */
(function () {
  if (!window.themeVariables || window.themeVariables.settings.pageType !== 'product') return;

  // Rename "Add to cart" buttons to "Buy now" so the label matches the behaviour
  function relabelButtons() {
    document.querySelectorAll('button[type="submit"]').forEach(function (btn) {
      var label = btn.textContent.trim().toLowerCase();
      if (label === 'add to cart') {
        btn.textContent = 'Buy now';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', relabelButtons);
  } else {
    relabelButtons();
  }

  // Re-run after variant switches (Impact re-renders the sticky bar)
  document.addEventListener('variant:change', relabelButtons);

  // Redirect to checkout after item is added to cart
  document.addEventListener('variant:add', function () {
    window.location.href = '/checkout';
  });
})();
